import React, { forwardRef } from "react";

const Card = forwardRef(function Card({ className = "", children, as: Tag = "div", ...props }, ref) {
  return (
    <Tag
      ref={ref}
      className={`rounded-lg border border-slate-200 bg-white shadow-card ${className}`}
      {...props}
    >
      {children}
    </Tag>
  );
});

export default Card;
